import type {
  EstimateManagerDeliveryDateOption,
  EstimateManagerProductResponse,
} from '../../../core/models/estimates-orchestrator';

/**
 * Picks the earliest priced Product × EDD row for a selected product after a pickup-date re-estimate.
 * Prefers matching transportation mode when the response includes it (ESN parity for OM-754).
 */
export function pickEarliestEstimateProduct(input: {
  dates: EstimateManagerDeliveryDateOption[];
  productCode: string;
  transportationMode?: string;
}): EstimateManagerProductResponse | undefined {
  const productCode = input.productCode.trim();
  if (!productCode || input.dates.length === 0) {
    return undefined;
  }

  const sortedDates = [...input.dates].sort((left, right) =>
    left.expectedDeliveryDate
      .replaceAll('/', '-')
      .localeCompare(right.expectedDeliveryDate.replaceAll('/', '-')),
  );

  for (const dateOption of sortedDates) {
    const match = dateOption.products.find((candidate) => {
      const code =
        candidate.product?.productCode?.trim() ||
        candidate.serviceAvailability?.productCode?.trim();
      if (code !== productCode) {
        return false;
      }
      if (candidate.estimate?.outcome !== 'RATING_SUCCESS' || !candidate.estimate?.pricing) {
        return false;
      }
      const mode = candidate.serviceAvailability?.transportationMode?.trim();
      return !mode || !input.transportationMode || mode === input.transportationMode;
    });
    if (match) {
      return match;
    }
  }

  return undefined;
}
